import React, { useState, useEffect, useContext } from 'react'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg,
    ProgressBarDiv,
    ProgressBarCircle,
    ProgressBarLine,
    InputRowDiv,
    InputDiv,
    InputLabel,
    Input,
    SelectInput,
    SelectOption,
    ButtonsDiv,
    PreviousButtonDiv,
    PreviousButtonImage,
    PreviousButtonText,
    NextButtonDiv,
    NextButtonImage,
    NextButtonText,
    WarningDiv,
    WarningText
 } from './style'
import ModalContext from '../../../../contexts/ModalContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/pages/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/pages/arrow-left.svg'
import { FieldsToHeaders, fieldsToHeaders, StockInterface } from '../../../../pages/ClientPanel/Stock/StockTable/utils'
import { Info } from 'lucide-react'

const SecondCustomAddPage: React.FC = () => {
    const { stock, setStock } = useContext(StockContext)
    const { setModalActive, setModalSection, itIsUpdate } = useContext(ModalContext)
    const [ activeMenu, setActiveMenu ] = useState(0)
    const [ warningMessage, setWarningMessage ] = useState(false)
    const [ isNextDisabled, setIsNextDisabled ] = useState(true)
    const [errors, setErrors] = useState<{ [key: string]: boolean }>({});


    useEffect(() => {
        setWarningMessage(false)
    }, [stock])

    useEffect(() => {
        const requiredFields = ['dimension1'];
        if (stock.measurementUnit === 'KG') {
            requiredFields.push('totalWeight', 'costPerKg');
        } else if (stock.measurementUnit === 'MM') {
            requiredFields.push('lengthInMm', 'costPerMm');
        }
    
        // Verifica se todos os campos obrigatórios estão preenchidos
        const allFieldsFilled = requiredFields.every(field => stock[field as keyof StockInterface]);
        setIsNextDisabled(!allFieldsFilled);
    
        // Atualiza os erros para mostrar os ícones vermelhos nos campos vazios
        const newErrors: { [key: string]: boolean } = {};
        requiredFields.forEach((field) => {
            newErrors[field] = !stock[field as keyof StockInterface]; // Se vazio, erro = true
        });
    
        setErrors(newErrors); // Atualiza os erros
    }, [stock]);
    

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        if (isNaN(Number(value))){
            setWarningMessage(true)
            return
        }
        setStock({
            ...stock,
            [name]: value
        })
    }

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target
        setStock({
            ...stock,
            [name]: value
        })
    }

    const previousPage = () => {
        setModalSection('firstCustomAdd')
    }

    const nextPage = () => {
        if (!isNextDisabled) {
            setModalSection('thirdCustomAdd')
        }
    }

    const fieldsArray: string[][] = [
        ['quantity', 'totalWeight', 'totalCmc'],
        ['measurementUnit', 'dimension1', 'dimension2'],
        ['lengthInMm', 'costPerKg', 'costPerMm']
    ]

    return (
        <Container>
            <HeaderDiv>
                <HeaderText>{itIsUpdate ? 'Editar Estoque' : 'Adicionar Estoque'}</HeaderText>
                <CloseDiv onClick={() => setModalActive(false)}>
                    <CloseImg src={cross} alt='Close tab'/>
                </CloseDiv>
            </HeaderDiv>
            <ProgressBarDiv>
                <ProgressBarCircle className='active'/>
                <ProgressBarLine className='active'/>
                <ProgressBarCircle className='active'/>
                <ProgressBarLine/>
                <ProgressBarCircle/>
            </ProgressBarDiv>
            {fieldsArray.map((inputRow, rowIndex) => (
                <InputRowDiv key={rowIndex}>
                    {inputRow.map((stockField: string, colIndex) =>(
                        <InputDiv key={colIndex}>
                            <InputLabel htmlFor={stockField}>
                                {fieldsToHeaders[stockField as keyof FieldsToHeaders]}
                                {errors[stockField] !== undefined && (
                                    <Info size={15} style={{marginLeft:5}} color={`${!stock[stockField as keyof StockInterface] ? 'red' : 'gray'}`}/>
                                )}
                            </InputLabel>
                            {   
                                stockField !== 'measurementUnit' ?
                                <Input 
                                    placeholder='Digite aqui'
                                    name={stockField}
                                    value={stock[stockField as keyof StockInterface]}
                                    onFocus={() => setActiveMenu(rowIndex*3+colIndex+1)}
                                    onBlur={() => setActiveMenu(0)}
                                    onChange={handleChange}
                                    autoComplete="off"
                                /> :    
                                <SelectInput 
                                    name={stockField}
                                    value={stock[stockField as keyof StockInterface]}
                                    onChange={(e) => handleSelectChange(e)}
                                >
                                    <SelectOption value="KG">KG</SelectOption>
                                    <SelectOption value="MM">MM</SelectOption>
                                </SelectInput>
                            }
                        </InputDiv>
                    ))}
                </InputRowDiv>
            ))}
            <ButtonsDiv>
                <WarningDiv>
                    <WarningText>{warningMessage ? "Todos os campos nesta página precisam ser números!" : null}</WarningText>
                </WarningDiv>
                <PreviousButtonDiv onClick={previousPage}>
                    <PreviousButtonImage src={arrowLeft} alt='Right arrow icon'/>
                    <PreviousButtonText>Voltar</PreviousButtonText>
                </PreviousButtonDiv>
                <NextButtonDiv onClick={nextPage} style={{ opacity: isNextDisabled ? 0.5 : 1, pointerEvents: isNextDisabled ? 'none' : 'auto' }}>
                    <NextButtonImage src={arrowRight} alt='Right arrow icon'/>
                    <NextButtonText>Próximo</NextButtonText>
                </NextButtonDiv>
            </ButtonsDiv>
        </Container>
    )
}

export default SecondCustomAddPage
